import React from 'react';
import { Container } from 'reactstrap';
import Slider from "react-slick";

import priyanshuImg from '../assets/profile/Priyanshu.jpg.jpeg';
import rohitImg from '../assets/profile/Rohit.jpeg';
import dharuvImg from '../assets/profile/Dharuv.png';
import pairaveeImg from '../assets/profile/Pairavee_Mohandass.jpg';
import SanjuImg from '../assets/profile/Sanju.jpg';
import varshaImg from '../assets/profile/Varsha_Sharma.jpeg';
import shubhiImg from '../assets/profile/Shubhi.jpg';
import sumitImg from '../assets/profile/sumit.png';

import './TestimonialComponent.css';

const testimonials = [
  {
    id: 1,
    name: "Priyanshu Sharma",
    role: "User",
    company: "Jarguar",
    text: "For me, BetelJobs takes the stress out of audit work by simplifying basic verification tasks into a clear and manageable process. It’s perfect for staying organized and efficient without needing advanced technical skills.",
    image: priyanshuImg
  },
  {
    id: 2,
    name: "Rohit",
    role: "User",
    company: "Ticketbox",
    text: "BetelJobs is a great option for earning extra income through simple audit assignments.",
    image: rohitImg
  },
  {
    id: 3,
    name: "Dharuv",
    role: "User",
    company: "Konstruct",
    text: "Perfect side hustle for graduates who want flexible, on-site work.",
    image: dharuvImg
  },
  {
    id: 4,
    name: "Pairavee Mohandass",
    role: "User",
    company: "TechFlow",
    text: "BetelJobs helped me earn per task without committing to a full-time job",
    image: pairaveeImg
  },
  {
    id: 5,
    name: "Sanju Devi",
    role: "User",
    company: "LogiChain",
    text: "What I like about BetelJobs is that the work is straightforward and supported by backend team. Many opportunities where no complicated finance background needed.",
    image: SanjuImg
  },
  {
    id: 6,
    name: "Varsha Sharma",
    role: "User",
    company: "User",
    text: "Betel jobs platform is really useful for students or homemakers looking for part-time field work.",
    image: varshaImg
  },
  {
    id: 7,
    name: "Shubhi Modi",
    role: "User",
    company: "User",
    text: "Currently I sincerely appreciate this wonderful opportunity provided by Betel Jobs for auditors. It’s inspiring to see a platform that welcomes freshers, homemakers returning to work, and experienced professionals alike. It turned out to be a big milestone for me in my career .",
    image: shubhiImg
  },
  {
    id: 8,
    name: "Sumit Khairge",
    role: "User",
    company: "User",
    text: "Assignments are location-based, and the process is very smooth",
    image: sumitImg
  }
];

const TestimonialCarousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    speed: 5000,
    autoplaySpeed: 1000,
    pauseOnHover: true,
    cssEase: "linear",
    arrows: true,
    responsive: [
      {
        breakpoint: 996,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Container className="py-5">
      <div className="text-center mb-5">
        <h4 className="text-center mb-3 section-title text-dark">What our Users say</h4>
      </div>
      <div className="slider-container mx-3">
        <Slider {...settings} className="testimonial-slider" key={testimonials.length}>
          {testimonials.map((testimonial, idx) => (
            <div key={testimonial.id} className="px-3" style={{ height: '100%' }}>
              <div className="h-100 p-4 d-flex flex-column border shadow-sm feature-cardOne-adjustments bg-white testimonial-card-wrapper" style={{ borderRadius: '5px', minHeight: '240px', display: 'flex' }}>

                {/* Company name removed/hidden as per previous code, purely text/footer now */}

                <div className="mb-1" style={{ flex: '1' }}>
                  <p style={{ color: '#666', fontSize: '16px', lineHeight: '1.6' }}>"{testimonial.text}"</p>
                </div>

                <div className="mt-auto d-flex align-items-center" style={{ gap: '12px' }}>
                  <div style={{ width: '60px', height: '60px', minWidth: '60px', borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <h6 style={{ color: '#002a5c', fontWeight: 'bold', marginBottom: '5px' }}>{testimonial.name}</h6>
                    <p style={{ color: '#888', fontSize: '14px', marginBottom: 0 }}>{testimonial.role}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </Container>
  );
};

export default TestimonialCarousel;